<div class="mat-typography mat-body mat-app-background">
  <section class="header-and-zip-and-print">
    <!-- HEADER -->
    <h1>Compare Plans</h1>

    @if (showSaveQuoteButton) {
      <app-save-quote-button
        [saveQuoteText]="saveQuoteText" [enrollmentFlow]="enrollmentFlow" [returnUrl]="returnUrl" [quoteButtonPage]="quoteButtonPage">
      </app-save-quote-button>
    }

    <div class="zip-and-print pull-right min-width-20">
      @if (enableNewPrintExperience) {
        <app-plan-details-pdf-print></app-plan-details-pdf-print>
      } @else {
        <app-print-button></app-print-button>
      }
    </div>
  </section>

  <!-- CARD -->
  <section class="header-cards">
    <div class="card-container">
      @for (plan of plans; track plan) {
        <app-compare-plan-card
          [enrollStartUrl]="enrollStartUrl"
          [specialEnrollmentUrl]="specialEnrollmentUrl"
          [plan]="plan"
          [isSep]="isSep">
        </app-compare-plan-card>
      }
    </div>

  </section>
</div>
